import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { repeat, retry, share } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  socket!: WebSocketSubject<any>;
  messages$!: Observable<any>;
  storageManager: BrowserStorageService = new BrowserStorageService();
  private readonly RECONNECT_INTERVAL = 1000;

  constructor() {}

  // Debe llamarse despues de validar/guardar el signedToken en session storage,
  // ya que la URL del socket se construye con el token en ese momento.
  initConnection() {
    this.socket = webSocket({
      url:
        environment.urlWebSocket +
        '?token=' +
        this.storageManager.get('signedToken', 'session'),
      binaryType: 'arraybuffer',
      deserializer: ({ data }) => {
        const msg = JSON.parse(data);
        return msg;
      },
    });
    // retry reconecta cuando la conexion falla con error; repeat reconecta
    // cuando el servidor la cierra limpiamente (p. ej. timeout de inactividad),
    // caso en el que el stream completa sin error.
    this.messages$ = this.socket.pipe(
      retry({ delay: this.RECONNECT_INTERVAL }),
      repeat({ delay: this.RECONNECT_INTERVAL }),
      share()
    );
  }
}
